import PortalHelpPage from "./PortalHelpPage";

export default PortalHelpPage;
